var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50044 10.9L11.0002 1L20.5002 10.9L18.2002 8.50316V17.4C18.2002 17.8243 18.0316 18.2313 17.7316 18.5314C17.4315 18.8314 17.0245 19 16.6002 19H5.40021C4.97586 19 4.56889 18.8314 4.26884 18.5314C3.96878 18.2313 3.80021 17.8243 3.80021 17.4V8.51652L1.50044 10.9Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.c975210003249d794b6da93e151d32a1.svg";
export { ForwardRef as ReactComponent };